import sdkProvider from "src/utilities/sdkProvider";
import noticeError from "src/app/utilities/noticeError";

export default async function isFeatureEnabled(featureName) {
  try {
    const features = await sdkProvider("features");
    await features.onReady();
    const feature = features.getFeature(featureName);
    const enabled = feature.isEnabled();

    return enabled;
  } catch (error) {
    noticeError(error);

    return false;
  }
}
